import template from './ceiling-height.jade';
import validation from './../../../services/validation';

export default angular
    .module('cian.addForm.ceilingHeight', [])
    .directive('cianAfAboutBuildingCeilingHeight', () => ({
        scope: {},
        bindToController: {
            ad: '=',
            form: '=',
        },
        controller: ['deviceService', function (deviceService) {
            this.isMobile = deviceService.isMobile;
            this.maxHeight = 100;
            this.minHeight = 0;

            this.validation = validation(this.form, 'building.ceilingHeight', {
                parse: 'Введите число',
                max: 'Допустимо не более 2 символов',
                min: 'Введите число',
            });
        }],
        controllerAs: 'ceilingHeight',
        template,
    }))
    .name;
